import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import SectionGames from '../studentDashboard/SectionGames'

const PopupResources: FC = () => {
  const { t } = useTranslation()


  return (
      <><SectionGames iframe={true} /></>
  )
}

export default PopupResources
